import React, {PureComponent, useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import {connect, useSelector, useDispatch} from 'react-redux';
import moment from 'moment';
import {validators} from '../../../validation';
import Field from '../../Field';
import CongregationInput from '../../CongregationInput';
import ServiceTimeInput from '../../ServiceTimeInput';
import {
  setCongregation,
  setCongregationErrors
} from '../../../actions/congregations';
import {
  setServiceTime,
  setServiceTimeErrors
} from '../../../actions/serviceTimes';
import {
  setDate
} from '../../../actions/visit';
import './CongregationForm.less';


const CongregationField = connect(
  state => ({
    value: state.congregations.selected,
    errors: state.congregations.errors,
    validators: [validators.required()]
  }),
  dispatch => ({
    onChange(value) {
      dispatch(setCongregation(value));
    },
    setErrors(errors) {
      dispatch(setCongregationErrors(errors));
    }
  })
)(Field);


// const ServiceTimeField = connect(
//   state => ({
//     value: state.serviceTimes.selected,
//     errors: state.serviceTimes.errors,
//     validators: [validators.required()]
//   }),
//   dispatch => ({
//     onChange(value) {
//       dispatch(setServiceTime(value));
//     },
//     setErrors(errors) {
//       dispatch(setServiceTimeErrors(errors));
//     }
//   })
// )(Field);


function ServiceTimeField({children}) {
  const {errors, selected: value} = useSelector(state => state.serviceTimes);
  const congregationId = useSelector(state => state.congregations.selected);
  const [v] = useState([validators.required()]);
  const dispatch = useDispatch();

  const onChange = useCallback(value => {
    dispatch(setServiceTime(value));
  });

  const setErrors = useCallback(errors => {
    dispatch(setServiceTimeErrors(errors));
  });

  useEffect(() => {
    setServiceTime(null);
    setErrors(["This field is required."]);
  }, [congregationId]);

  return (
    <Field value={value} errors={errors} validators={v}
        onChange={onChange} setErrors={setErrors}>{children}</Field>
  );
}


function DateField({children}) {
  const [errors, setErrors] = useState(['This field is required.']);
  const [v] = useState([validators.required()]);
  const dispatch = useDispatch();
  const value = useSelector(state => state.visit.date);
  const onChange = useCallback(value => {
    dispatch(setDate(value));
  });

  return <Field value={value} errors={errors} validators={v}
      onChange={onChange} setErrors={setErrors}>{children}</Field>;
}


function useSundays() {
  const firstSunday = moment().day('Sunday');
  if (firstSunday.isBefore(moment(), 'day')) {
    firstSunday.add(1, 'week');
  }
  const lastSunday = firstSunday.clone().add(12, 'weeks');
  const sundays = [];
  let sunday = firstSunday;

  while (sunday.isSameOrBefore(lastSunday, 'day')) {
    sundays.push(sunday);
    sunday = sunday.clone().add(1, 'week');
  }

  return sundays;
}


export function getDays(dow) {
  const firstSunday = moment().day(dow);
  if (firstSunday.isBefore(moment(), 'day')) {
    firstSunday.add(1, 'week');
  }
  const lastSunday = firstSunday.clone().add(12, 'weeks');
  const sundays = [];
  let sunday = firstSunday;

  while (sunday.isSameOrBefore(lastSunday, 'day')) {
    sundays.push(sunday);
    sunday = sunday.clone().add(1, 'week');
  }

  return sundays.map(i => i.toDate());
}


function DateInput({onChange}) {
  const onChangeHandler = useCallback(event => {
    onChange(event.target.value);
  });
  const congregationId = useSelector(state => state.congregations.selected);
  const serviceTimes = useSelector(state => state.serviceTimes.data);
  const value = useSelector(state => state.visit.date);
  const [days, setDays] = useState([]);

  useEffect(() => {
    if (congregationId) {
      let daysOfWeek = {};
      let newDays = [];
      for (let serviceTime of serviceTimes) {
        if (serviceTime.Congregation_ID === congregationId) {
          daysOfWeek[serviceTime.Day] = true;
        }
      }
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].forEach(dow => {
        if (daysOfWeek[dow]) {
          newDays = [...newDays, ...getDays(dow)];
        }
      });
      setDays(newDays.sort((a, b) =>
        a > b ? 1 : -1
      ).map(i => moment(i)));
      onChange(null);
    }
    else {
      setDays([]);
      onChange(null);
    }
  }, [congregationId, serviceTimes]);

  return (
    <select className="date-input" onChange={onChangeHandler} value={value || ''}>
      <option>Date</option>
      {days.map(day =>
        <option value={day.format('YYYY-MM-DD')} key={day.format('YYYY-MM-DD')}>{day.format('dddd - MM/DD/YYYY')}</option>
      )}
    </select>
  );
}


export default class CongregationForm extends PureComponent {
  render() {
    return (
      <div className="congregation-form">
        <CongregationField>
          <CongregationInput />
        </CongregationField>
        <DateField>
          <DateInput />
        </DateField>
        <ServiceTimeField>
          <ServiceTimeInput />
        </ServiceTimeField>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/form-route/forms/CongregationForm.js